module.exports = __webpack_public_path__ + "static/img/xiaohuangren-new.806a245c.png";